import { render, staticRenderFns } from "./CustomInput.vue?vue&type=template&id=bd4d3858&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"
import style0 from "./CustomInput.vue?vue&type=style&index=0&id=bd4d3858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d3858",
  null
  
)

export default component.exports